import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd022aService,
  Sgkd022aRequest,
  Sgkd022aResponse,
  Sgkd022aRequestKozadisadReqretInfoarea
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd010dSgkd022aService {

  private _rsesult$ = new Subject<Sgkd022aResponse>();

  constructor(
    private sgkd022aService: Sgkd022aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 口座振替依頼返却内訳表データ作成API呼び出し
   * @param list 口座振替依頼返却情報リスト
   * @memberof UsedSgkd010dSgkd022aService
   */
  print(list: Array<Sgkd022aRequestKozadisadReqretInfoarea>): Observable<Sgkd022aResponse> {

    // リクエスト生成
    let request: Sgkd022aRequest = {
      requestDto: {
        accounttransferrequestReturnInformationlist: list
      }
    };

    return this.sgkd022aService.doSGKD022APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // コンテントタイプを取得
          const contentType = response.headers.get('Content-Type');

          if (contentType === 'application/octet-stream') {
            // ファイルが取得できた場合																							
            const fileBlob = new Blob([response.body], { type: contentType });
            const contentDisposition: string = response.headers.get('Content-Disposition');
            // 正規表現を使って、文字列からファイル名の抽出																						
            const matchesFileName: RegExpExecArray = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
            // matchesFileName[1] に含まれるクォーテーション（' または "）をすべて削除しています																							
            const fileName: string = matchesFileName[1].replace(/['"]/g, '');
            // ヘッダ名「file-name」だった場合																																														
            const fileNameDecode: string = decodeURIComponent(fileName);
            // ファイルとしてダウンロード
            this.anchorDownload(fileBlob, fileNameDecode, document);
            return response.body;
          } else if (this.sgkd022aService.configuration.isJsonMime(contentType)) {
            // JSONとして処理
            const textDecoder = new TextDecoder('utf-8');
            // ArrayBufferを文字列に変換
            const jsonString = textDecoder.decode(response.body);
            // JSONオブジェクトに変換
            const jsonResponse = JSON.parse(jsonString); 
            this.apiCommonService.checkError(response.clone({ body: jsonResponse }));
            return response.body;
          }
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD022A');
          return throwError(err.message);
        }
      )
    );
  }

  /**
   * 渡されたBlobオブジェクトとファイル名を元に内部でAnchor要素を作成し、
   * ブラウザ上でファイルとしてダウンロードする
   * @param {Blob} response
   * @param {string} filename
   * @param {Document} document
   * @memberof UsedSgkd010dSgkd022aService
   */
  anchorDownload(response: Blob, filename: string, document: Document): void {
    // 取得した情報をアンカー要素のURLに指定
    let downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(response);
    // ダウンロード属性を指定して、ファイルとしてダウンロードするように指定
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    // アンカー要素をクリックしてダウンロード
    downloadLink.click();
    // 追加した要素を削除
    document.body.removeChild(downloadLink);
  }
}
